import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import EmbedApp from './EmbedApp';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';

const isEmbedMode =
    window.location.pathname === '/embed' || window.location.pathname === '/embed/';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ErrorBoundary>
            {isEmbedMode ? <EmbedApp /> : <App />}
        </ErrorBoundary>
    </React.StrictMode>,
);

document.documentElement.dataset.coordalApp = 'ready';

void import('./lib/sentry').then((m) => m.initSentry());
void import('./lib/posthog').then((m) => m.initPostHog());
